import * as React from "react";
const SvgMybooks = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.2574,21.594l-7.2574-4.9901-7.2574,4.9901V2.98c0-.83.5987-1.5,1.3426-1.5h11.8296c.7439,0,1.3426.67,1.3426,1.5v18.614Z", style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }));
export default SvgMybooks;
